import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setWasmUrl } from '@lottiefiles/dotlottie-vue'

import App from './App.vue'
import { router } from './router'

import './styles/main.css'

setWasmUrl(`${import.meta.env.BASE_URL.replace(/\/$/, '')}/dotlottie-player.wasm`)

/**
 * 尝试锁定屏幕方向为横屏.
 *
 * 行为分布:
 *   - Android Chrome PWA (添加到主屏幕): manifest 已声明 landscape, 启动
 *     即锁; 这里再调一次幂等, 多一层保险.
 *   - Android Chrome 普通浏览器: 部分版本支持, 进 fullscreen 后才能锁;
 *     不进 fullscreen 时 lock() 会 reject, 我们静默吞掉.
 *   - iOS Safari (普通 + PWA): 完全不实现 screen.orientation.lock() —
 *     立即抛 NotSupportedError, 静默吞掉. iOS 上无 web 层方案可强制锁横屏
 *     (Apple 限制), 由 RoomPage 的 portrait 遮罩兜底提示用户旋转手机.
 *
 * 之所以 `as any`: TypeScript 的 lib.dom.d.ts 在部分版本里没把 lock 标到
 * ScreenOrientation 类型上 (它是 Screen Orientation API Level 1 的提案
 * 阶段方法).
 */
function tryLockLandscape(): void {
  const so = screen.orientation as unknown as {
    lock?: (orientation: string) => Promise<void>
  } | undefined
  if (!so || typeof so.lock !== 'function') return
  so.lock('landscape').catch(() => {
    /* 失败原因可能是: 不支持 / 不在 fullscreen / 已经是横屏 — 一律忽略 */
  })
}

tryLockLandscape()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
